module.exports = __webpack_public_path__ + "adea74b30ad144dd3d0992b6f9dccc16.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Tapered Baguette.png
// module id = 787
// module chunks = 0